import { IconButton, Paper, Slide, TablePagination } from "@material-ui/core";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import React, { useState } from "react";
import { useQueryContext } from "../../../context";

export default ({ colSpan }) => {
  const {
    pagination: {
      currentPage,
      lastPage,
      nextPage,
      totalRecords,
      perPage,
      totalPages,
    },
    setNewPage,
    setPerPage,
  } = useQueryContext();

  const [invalidPage, setInvalidPage] = useState(false);

  return (
    <Slide in={true} direction="left" timeout={300}>
      <Paper elevation={1}>
        <TablePagination
          component="div"
          colSpan={colSpan}
          labelRowsPerPage="Precatórios por página: "
          nextIconButtonText="Próxima página"
          backIconButtonText="Página anterior"
          labelDisplayedRows={({ from, to, count }) => {
            const undefCount = `mais que ${to}`;

            return (
              <span className="pagination-counter">{`${from}-${to} de ${
                count !== -1 ? count : undefCount
              }`}</span>
            );
          }}
          page={currentPage - 1}
          count={totalRecords}
          rowsPerPage={perPage}
          onChangePage={setNewPage}
          onChangeRowsPerPage={(event) => {
            const rowsPerPage = Number(event.target.value);
            setPerPage(rowsPerPage);
          }}
          SelectProps={{
            inputProps: { "aria-label": "Precatórios por página" },
            native: true,
          }}
          ActionsComponent={(props) => {
            const { onChangePage } = props;

            return (
              <div className="q-pagination-actions">
                <IconButton
                  onClick={() => onChangePage(1)}
                  disabled={currentPage == 1}
                  aria-label="primeira"
                >
                  <FirstPageIcon />
                </IconButton>

                <IconButton
                  onClick={() => onChangePage(currentPage - 1)}
                  disabled={currentPage == 1}
                  aria-label="anterior"
                >
                  <KeyboardArrowLeft />
                </IconButton>

                <IconButton
                  onClick={() => onChangePage(nextPage)}
                  disabled={currentPage == lastPage}
                  aria-label="proxima"
                >
                  <KeyboardArrowRight />
                </IconButton>

                <IconButton
                  onClick={() => onChangePage(lastPage)}
                  disabled={currentPage == lastPage}
                  aria-label="ultima"
                >
                  <LastPageIcon />
                </IconButton>

                <span className="q-pagination-page-container">
                  Ir para página:{" "}
                  <input
                    type="number"
                    defaultValue={currentPage}
                    className="q-pagination-page-input"
                    min={1}
                    max={totalPages}
                    onBlur={(e) => {
                      e.preventDefault();
                      const pg = e.target.value;

                      if (pg != "") {
                        if (pg <= 0 || pg > lastPage) {
                          setInvalidPage(true);
                          return;
                        }

                        onChangePage(Number(pg));
                      }
                    }}
                  />
                </span>
              </div>
            );
          }}
        />
      </Paper>
    </Slide>
  );
};
